import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { IncidentDetailsFillState } from '@mobile/views/Relation/DetailsPanel/enums'

import { isZoneAttributeSelected } from '../components/FieldZonesModal/utils'
import { zones } from './consts'

export function getIncidentDetailsFillState(incident: ProbableIncident): {
  state: IncidentDetailsFillState
} {
  const zoneGroupFulfilled = isZoneAttributeSelected(
    incident.attribute_ids,
    Array.from(zones.values()),
  )
  const state = zoneGroupFulfilled
    ? IncidentDetailsFillState.Filled
    : IncidentDetailsFillState.NotFilled

  return { state }
}
